<template> 
  <div class="app-container">
    <!-- <el-card v-if="searchData.length != 0" class="filter-container" shadow="never">
      <div class="filter-title">
        <div class="text">
          <i class="el-icon-search"></i>
          <span>筛选搜索</span>
        </div>
        <div class="operate">
          <el-button type="primary" @click="handleSearchList()" size="small">搜索</el-button>
          <el-button @click="handleResetSearch()" size="small">重置</el-button>
        </div>
      </div>
      <el-form :inline="true" class="global_res" :model="listQuery" label-width="120px" size="small">
        <el-form-item  v-show="$store.state.fold.isFold ? true : (index < 3)" :label="$utils.labelByValue_global(item)+':'" v-for="(item,index) in searchData" :key="index">
          <inputCon :params = item></inputCon>
        </el-form-item>
        <div v-show="searchData.length > 3" class="global_zd" @click="$store.commit('set_isFold',$store.state.fold.isFold)">
          <span class="global_zd_t">{{$store.state.fold.isFold ? '关闭' : '展开'  }}</span>
          <span class="global_zd_icon"><i :class="$store.state.fold.isFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i></span>
        </div>
      </el-form>
    </el-card> -->
    <!-- <el-button type="primary" icon="el-icon-plus" class="btn-add" @click="handleClick('','1')">添加</el-button> -->
     <div>合计:{{ amtTotal }} 元</div>
    <el-table ref="adminTable" :data="tableData" style="width: 100%; margin-top: 20px;" v-loading="listLoading" border>
      <el-table-column  v-for="(item,index) in tableLabelList" :key="index" 
            align="center"  :label="$utils.labelByValue_global(item)" :width="item.width" 
            :min-width="`${item.width ? Number(item.width - 30) : 120}`">
          <template slot-scope="scope">
            <div v-if="item.inputType == 'img'">
              <el-image 
                style="width: 100px; height: 100px"
                :src="$utils.rValByFiled(scope.row,item)" 
                :preview-src-list="[$utils.rValByFiled(scope.row,item)]">
            </el-image>
            </div>
            <!-- <div v-else>
              {{$utils.rValByFiled(scope.row,item) }}
            </div> -->
            <div v-else class="tableLabelHidden" :style="{minWidth:`${item.width ? Number(item.width - 30) : 90}px`}"  
              :title="$utils.rValByFiled(scope.row,item)">
              {{$utils.rValByFiled(scope.row,item,false,7) }}
            </div>
          </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleClick(scope.row,'2')">编辑</el-button>
          <el-button v-if="scope.row.flag == '0'" size="mini" type="text" @click="handleClick(scope.row,'4')">支付注册</el-button>
          <el-button size="mini" type="text" @click="handleClick(scope.row,'3')">删除</el-button>
          <el-button v-if="scope.row.flag == '1'" size="mini" type="text" @click="handleClick(scope.row,'5')">申请提现</el-button>
          <el-button v-if="scope.row.flag == '1'" size="mini" type="text" @click="handleClick(scope.row,'6')">转账</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total,sizes,prev,pager,next,jumper" :current-page.sync="listQuery.pageNum" :page-size="listQuery.pageSize" :page-sizes="[10,15,20,50,100]" :total="total"></el-pagination>
    </div> -->
    <dialogCon v-if="dialogData.dialogVisible" :params="dialogData" @listenDialog="listenDialog"></dialogCon>
   
  </div>
</template>
<script>
  import companyManagementApi from '@/api/companyManagementApi.js';
  import inputCon from '@/components/input'
  import dialogCon from '@/components/dialog'
  export default {
    name: 'adminList',
    components: {
      inputCon,dialogCon
    },
    data() {
      return {
        listQuery: {
          pageNum: 1,
          pageSize: 20,
        },
        total: null,
        listLoading: false,
        dialogData:{},//弹窗数据
        propData:{},
        rowId:0,
        //筛选数据结构
        searchData:[
          {inputType:'input',typeValue:'text',label:'公司名称',placeholder:'请输入公司名称',value:'',filed:'companyName'},
          // {inputType:'select',typeValue:'select',label:'帐号状态',placeholder:'请选择帐号状态',value:'',filed:'status',options:this.$utils.getOption("status")},
        ],
        receiverInfo:{
          bankProvince:'',
          bankCity:'',
        },
        merchantAddr:{
          province:'',
          city:'',
          district:'',
        },
        // 添加催收账号
        addElData:{
          dialogVisible:false,
          title:'添加',
          type:'1',//1添加  2编辑   3修改账号密码
          isRequired:true,//开启验证
          width:'700',
          isBtn:true,
          btnList:[
            {btnText:'确定'},
            {btnText:'取消'}
          ],
          isDisabled:false,
          labelList:[
          ],
          deepList:[
            {inputType:'input',typeValue:'text',label:'名称',placeholder:'请输入公司名称',value:'',filed:'name',isRequired:true},
            {inputType:'select',typeValue:'select',label:'公司类型',placeholder:'请选择公司类型',value:'',filed:'type',
            options:this.$utils.getOption("typeGs"),isRequired:true},
            {inputType:'input',typeValue:'text',label:'备注',placeholder:'请输入备注',value:'',filed:'note',},
           


           
            {inputType:'input',typeValue:'text',label:'开户许可证号',placeholder:'请输入开户许可证号',value:'',filed:'accountLicenseNo',},
            
            {inputType:'upload',typeValue:'fileGs',label:'开户许可证照片',placeholder:'请上传开户许可证照片',value:'',filed:'accountUrl',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'开户许可证照片','accountUrl')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('开户许可证照片')}
            },
            
            {inputType:'input',typeValue:'text',label:'详细地址(街道)',placeholder:'请输入详细地址(街道)',value:'',filed:'detailAddress',},
            
            {inputType:'select',typeValue:'select',label:'银行账户类型',placeholder:'请选择银行账户类型',value:'',filed:'bankAccountType',options:this.$utils.getOption("bankAccountType")},
           
            {inputType:'input',typeValue:'text',label:'收款银行卡号',placeholder:'请输入收款银行卡号',value:'',filed:'bankcode',},
            
            // {inputType:'input',typeValue:'text',label:'开户行所在的省份',placeholder:'请输入开户行所在的省份',value:'',filed:'bankProvince',},
            
            // {inputType:'input',typeValue:'text',label:'开户行所在城市',placeholder:'请输入开户行所在城市',value:'',filed:'bankCity',},
            {inputType:'area',typeValue:'area',label:'省/市/区',placeholder:'请选择开户行省/市/区',value:'',filed:'areaJoinStr',
              province:'',city:'',region:'',hideArea:true,
              getProvince:(data)=>{this.getProvince(data)},
              getCity:(data)=>{this.getCity(data)},
              getArea:(data)=>{this.getArea(data)},
              onSelectRegion:(data)=>{this.onSelectRegion(data,"省市区")},
            },

            
            {inputType:'input',typeValue:'text',label:'开户行所属总行联行号',placeholder:'请输入开户行所属总行联行号',value:'',filed:'bankId',},
            
            {inputType:'input',typeValue:'text',label:'开户行联行号',placeholder:'请输入开户行联行号',value:'',filed:'bankKey',},
            
            {inputType:'input',typeValue:'text',label:'收款银行',placeholder:'请输入收款银行',value:'',filed:'bankname',},
            
            {inputType:'input',typeValue:'text',label:'统一社会信用代码',placeholder:'请输入统一社会信用代码',value:'',filed:'tax',},
            {inputType:'input',typeValue:'text',label:'营业执照地址',placeholder:'请输入营业执照地址',value:'',filed:'taxAddr',},
            
            {inputType:'upload',typeValue:'fileGs',label:'营业执照图片',placeholder:'请上传营业执照图片',value:'',filed:'taxUrl',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'营业执照图片','taxUrl')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('营业执照图片')}
            },
            {inputType:'input',typeValue:'text',label:'公司电话',placeholder:'请输入公司电话',value:'',filed:'companyPhone',},
            
            {inputType:'upload',typeValue:'fileGs',label:'法人身份证正面',placeholder:'请上传法人身份证正面',value:'',filed:'card1Url',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'法人身份证正面','card1Url')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('法人身份证正面')}
            },
            {inputType:'upload',typeValue:'fileGs',label:'法人身份证反面',placeholder:'请上传法人身份证反面',value:'',filed:'card2Url',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'法人身份证反面','card2Url')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('法人身份证反面')}
            },
            
            {inputType:'input',typeValue:'text',label:'法人证件号',placeholder:'请输入法人证件号',value:'',filed:'legalCertNo',},
            
            {inputType:'input',typeValue:'text',label:'企业法人名称',placeholder:'请输入企业法人名称',value:'',filed:'legalName',},
            
            {inputType:'input',typeValue:'text',label:'开户行地址详情',placeholder:'请输入开户行地址详情',value:'',filed:'bankNameDetail',},
            
            {inputType:'input',typeValue:'text',label:'经办人邮箱',placeholder:'请输入经办人邮箱',value:'',filed:'transactorEmail',},
            
            {inputType:'input',typeValue:'text',label:'经办人身份证',placeholder:'请输入经办人身份证',value:'',filed:'transactorIdCard',},
            
            
            {inputType:'upload',typeValue:'fileGs',label:'经办人身份证反面',placeholder:'请上传经办人身份证反面',value:'',filed:'transactorIdCardBackUrl',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'经办人身份证反面','transactorIdCardBackUrl')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('经办人身份证反面')}
            },
            {inputType:'upload',typeValue:'fileGs',label:'经办人身份证正面',placeholder:'请上传经办人身份证正面',value:'',filed:'transactorIdCardFrontUrl',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'经办人身份证正面','transactorIdCardFrontUrl')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('经办人身份证正面')}
            },
            
            {inputType:'input',typeValue:'text',label:'经办人姓名',placeholder:'请输入经办人姓名',value:'',filed:'transactorName',},
            
            {inputType:'input',typeValue:'text',label:'经办人手机号',placeholder:'请输入经办人手机号',value:'',filed:'transactorPhone',},
            
            // {inputType:'input',typeValue:'text',label:'商户实际经营地所在省',placeholder:'请输入商户实际经营地所在省',value:'',filed:'province',},
            // {inputType:'input',typeValue:'text',label:'商户实际经营地所在市',placeholder:'请输入商户实际经营地所在市',value:'',filed:'city',},
            // {inputType:'input',typeValue:'text',label:'商户实际经营地所在区',placeholder:'请输入商户实际经营地所在区',value:'',filed:'district',},
            
            {inputType:'area',typeValue:'area',label:'商户省/市/区',placeholder:'请选择商户省/市/区',value:'',filed:'areaJoinStr11',
              province:'',city:'',region:'',
              getProvince:(data)=>{this.getProvince(data)},
              getCity:(data)=>{this.getCity(data)},
              getArea:(data)=>{this.getArea(data)},
              onSelectRegion:(data)=>{this.onSelectRegion(data)},
            },
            {inputType:'upload',typeValue:'fileGs',label:'经营场所的照片/手持',placeholder:'请上传经营场所的照片/手持',value:'',filed:'premisesUrl',
            handleSuccess:(res, file, fileList)=>{this.handleSuccess(res, file, fileList,'经营场所的照片/手持','premisesUrl')},
            beforeAvatarUpload:( file)=>{return this.beforeAvatarUpload(file)},
            closeFun:()=>{this.closeFun('经营场所的照片/手持')}
            },
            
            {inputType:'input',typeValue:'text',label:'排序',placeholder:'请输入排序',value:'',filed:'sort',},
          ]
        },
        // table数据列表
        tableData:[],
        //table  label数据结构
        tableLabelList:[
          // {label:'序号',width:"60",value:'',filed:'id'},
          {label:'公司名称',value:'',filed:'name',},
          {label:'公司余额',value:'',filed:'companyNameAmt',},
          // {label:'公司类型',value:'',filed:'type',type:12},
          // {label:'备注信息',value:'',filed:'note',},
          // {label:'状态',value:'',filed:'status',type:1},
          // {label:'开户许可证号',value:'',filed:'accountLicenseNo',},
          // {label:'开户许可证照片',inputType:'img',value:'',filed:'accountUrl',},
          // {label:'详细地址(街道)',value:'',filed:'detailAddress',},
          // {label:'银行账户类型',value:'',filed:'bankAccountType',type:1},
          // {label:'收款银行卡号',value:'',filed:'bankcode',},
          // {label:'开户行所在的省份',value:'',filed:'bankProvince',},
          // {label:'开户行所在城市',value:'',filed:'bankCity',},
          // {label:'开户行所属总行联行号',value:'',filed:'bankId',},
          // {label:'开户行联行号',value:'',filed:'bankKey',},
          // {label:'统一社会信用代码',value:'',filed:'tax',},
          // {label:'营业执照地址',value:'',filed:'taxAddr',},
          // {label:'营业执照图',value:'',inputType:'img',filed:'taxUrl',},
          // {label:'公司电话',value:'',filed:'companyPhone',},
          // {label:'法人证件号',value:'',filed:'legalCertNo',},
          // {label:'企业法人名称',value:'',filed:'legalName',},
          // {label:'开户行地址详情',value:'',filed:'bankNameDetail',},
          // {label:'经办人邮箱',value:'',filed:'transactorEmail',},
          // {label:'经办人身份证',value:'',filed:'transactorIdCard',},
          // {label:'经办人姓名',value:'',filed:'transactorName',},
          // {label:'经办人手机号',value:'',filed:'transactorPhone',},
          // {label:'商户实际经营地所在省',value:'',filed:'province',},
          // {label:'商户实际经营地所在市',value:'',filed:'city',},
          // {label:'商户实际经营地所在区',value:'',filed:'district',},

          
          // {label:'创建时间',value:'',filed:'createTime',type:2},
        ],
        amtTotal:0,
      }
    },
    created() {
      this.getList();
    },
    destroyed () {
      this.$off("listenDialog")
    },
    methods: {
      getProvince(data){
        console.log("------------省-------------",data)
      },
      getCity(data){
        console.log("------------市-------------",data)
      },
      getArea(data){
        console.log("------------区-------------",data)
      },
      onSelectRegion(data,type){
        console.log("------------选择-------------",data)
        if(type == '省市区'){
          this.receiverInfo.bankProvince = data.province.value;
          this.receiverInfo.bankCity = data.city.value;
        }else{
          this.merchantAddr.province = data.province.value;
          this.merchantAddr.city = data.city.value;
          this.merchantAddr.district = data.area.value;
        }
      },
      // 查询列表信息
      getList() {
        this.listLoading = true;
        // let data = {...this.listQuery,...this.$utils.getDataObj(this.searchData)}
        companyManagementApi.queryCompanyBalance({})
        .then(response => {
          this.listLoading = false;
          this.tableData = response.data;
          for(let item of response.data){
            this.amtTotal += Number(item.companyNameAmt);
          }
          this.amtTotal = this.amtTotal.toFixed(2)
          // this.total = response.data.total;
        });
      },
      //监听dialog事件
      listenDialog(data){
        console.log("监听数据",data)
        let type = data.type || '0';
        let that=this,id;
        switch(type){
          case '1':
            
            data.data.accountUrl = that.$utils.getFiledVal("开户许可证照片",that.addElData.labelList)
            data.data.card1Url = that.$utils.getFiledVal("法人身份证正面",that.addElData.labelList)
            data.data.card2Url = that.$utils.getFiledVal("法人身份证反面",that.addElData.labelList)
            data.data.taxUrl = that.$utils.getFiledVal("营业执照图片",that.addElData.labelList)
            data.data.transactorIdCardBackUrl = that.$utils.getFiledVal("经办人身份证反面",that.addElData.labelList)
            data.data.transactorIdCardFrontUrl = that.$utils.getFiledVal("经办人身份证正面",that.addElData.labelList)
            data.data.premisesUrl = that.$utils.getFiledVal("经营场所的照片/手持",that.addElData.labelList)
            data.data = {...data.data,...that.receiverInfo,...that.merchantAddr}
            //添加
            companyManagementApi.createIntr(data.data)
              .then(res => {
                this.$message({
                  message: '添加成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
                this.getList();
              });
          break;
          case '2':
             //编辑
              id = that.rowId || '0';
            
              data.data.accountUrl = that.$utils.getFiledVal("开户许可证照片",that.addElData.labelList)
              data.data.card1Url = that.$utils.getFiledVal("法人身份证正面",that.addElData.labelList)
              data.data.card2Url = that.$utils.getFiledVal("法人身份证反面",that.addElData.labelList)
              data.data.taxUrl = that.$utils.getFiledVal("营业执照图片",that.addElData.labelList)
              data.data.transactorIdCardBackUrl = that.$utils.getFiledVal("经办人身份证反面",that.addElData.labelList)
              data.data.transactorIdCardFrontUrl = that.$utils.getFiledVal("经办人身份证正面",that.addElData.labelList)
              data.data.premisesUrl = that.$utils.getFiledVal("经营场所的照片/手持",that.addElData.labelList)
              data.data = {...data.data,...that.receiverInfo,...that.merchantAddr}
              companyManagementApi.updateIntr(id,data.data)
              .then(res => {
                this.$message({
                  message: '修改成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
                this.getList();
              });
          break;
          case '5':
            let data5 = data.data || {};
            if(data5.amt <= 0 || data5.amt > data5.beforeAmt){
              return that.$utils.msg("提现金额不能小于等于0或不能大于当前金额",'error')
            }
            data5.companyId = that.rowId
            companyManagementApi.withdrowApply(data5)
              .then(res => {
                this.$message({
                  message: '申请成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
                this.getList();
              });
          break;
          case '6':
            let data6 = data.data || {};
            // if(data6.amt <= 0 || data6.amt > data6.beforeAmt){
            //   return that.$utils.msg("转账金额不能小于等于0或不能大于当前金额",'error')
            // }
            data6.companyId = that.rowId
            companyManagementApi.channelTransfer(data6)
              .then(res => {
                this.$message({
                  message: '转账成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
                this.getList();
              });
          break;
          default:
            console.log("监听事件",data)
        }
      },
    //递归 深拷贝
    deepClone(obj){
        let objClone = Array.isArray(obj) ? [] :{};
        if(obj && typeof obj === 'object'){
            for(let key in obj){
                if(obj.hasOwnProperty(key)){
                    //判断obj子对象是否为对象，是  递归复制
                    if(obj[key] && typeof obj[key] === 'object'){
                        objClone[key] = this.deepClone(obj[key])
                    }else{
                        // 简单复制?
                        objClone[key] = obj[key]
                    }
                }
            }
        }
        return objClone;
    },
      //按钮操作
      async handleClick(row,type){
        let that = this,id,paramsData;
        this.rowId = row.id || '0';
        switch(type){
          case '1':
            //添加操作 
            let deepAddLableList = that.deepClone(that.addElData.deepList)
            that.addElData.labelList = deepAddLableList;
            that.dialogData = that.addElData;
            that.dialogData.title = "添加公司"
            that.dialogData.isResetbtn = false;
            that.addElData.type = '1';
            that.dialogData.dialogVisible = true;
          break;
          case '2':
            //编辑操作
            let deepUpdateLableList =  that.deepClone(that.addElData.deepList)
            that.addElData.labelList = deepUpdateLableList;
            that.dialogData = that.addElData;
            that.dialogData.title = "编辑公司"
            that.dialogData.isResetbtn = false;
            that.addElData.type = '2';
            //回显数据
            let dataObj = await companyManagementApi.checkByIdDetail(row.id,{})
            dataObj.data.bankAccountType = this.$utils.numTostring(dataObj.data.bankAccountType);
            dataObj.data.type = this.$utils.numTostring(dataObj.data.type);
            // dataObj.data.type = this.$utils.numTostring(dataObj.data.type);
            // dataObj.data.merchantId =this.$utils.numTostring(dataObj.data.merchantId);
            let obj1 = this.$utils.objEcho(this.receiverInfo,dataObj.data);
            let obj2 = this.$utils.objEcho(this.merchantAddr,dataObj.data);
            this.$utils.echoFiled("省/市/区","province",this.addElData.labelList,obj1['bankCity'])
            this.$utils.echoFiled("省/市/区","city",this.addElData.labelList,obj1['bankProvince'])
            this.$utils.echoFiled("商户省/市/区","province",this.addElData.labelList,obj2['province'])
            this.$utils.echoFiled("商户省/市/区","city",this.addElData.labelList,obj2['city'])
            this.$utils.echoFiled("商户省/市/区","region",this.addElData.labelList,obj2['district'])
            that.$utils.echoArrData(that.addElData.labelList,dataObj.data)
            that.dialogData.dialogVisible = true;
          break;
          case '3':
            // 删除
             id = row.id || '0';
             this.$confirm(`是否删除该条数据?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              companyManagementApi.deleteIntr(row.id,{})
              .then(res => {
                this.$message({
                  message: '删除成功',
                  type: 'success',
                  duration:1500
                })
                this.getList();
              });
            })
          break;
          case '4':
            //支付注册
             id = row.id || '0';
             this.$confirm(`是否确认注册?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              companyManagementApi.uploadFileIntr({id:id})
              .then(res => {
                this.$message({
                  message: '注册成功',
                  type: 'success',
                  duration:1500
                })
                this.getList();
              });
            })
          break;
          case '5':
            //回显数据
            let dataObj5 = await companyManagementApi.queryBalance(row.id);
            let jsonData = JSON.parse(dataObj5.data.info) || {};
            let curPrice = jsonData.balance ? jsonData.balance.amount : '0';
            console.log("================,",jsonData)
            //申请提现
            let returnLableList =  [
              {inputType:'input',labelWidth:'120px',typeValue:'text',label:'当前余额',placeholder:'请输入当前余额',value:curPrice,filed:'beforeAmt',disabled:true},
              {inputType:'input',labelWidth:'120px',typeValue:'number',label:'提现金额',placeholder:'请输入提现金额',value:curPrice,filed:'amt',isRequired:true},
              {inputType:'input',labelWidth:'120px',typeValue:'text',label:'备注',placeholder:'请输入备注',value:'',filed:'remark'},
            ]
            that.addElData.labelList = returnLableList;
            that.dialogData = that.addElData;
            that.dialogData.width = '700'
            that.dialogData.title = `申请提现`
            that.dialogData.isResetbtn = true;
            that.addElData.type = '5';
            that.dialogData.dialogVisible = true;
          break;
          case '6':
            //回显数据
            let dataObj6 = await companyManagementApi.queryBalance(row.id);
            let jsonData6 = JSON.parse(dataObj6.data.info) || {};
            let curPrice6 = jsonData6.balance ? jsonData6.balance.amount : '0';
            console.log("================,",jsonData6)
            //转账
            let returnLableList6 =  [
              {inputType:'input',labelWidth:'120px',typeValue:'text',label:'当前余额',placeholder:'请输入当前余额',value:curPrice6,filed:'beforeAmt',disabled:true},
              {inputType:'input',labelWidth:'120px',typeValue:'number',label:'转账金额',placeholder:'请输入转账金额',value:'',filed:'amt',isRequired:true},
              {inputType:'input',labelWidth:'120px',typeValue:'text',label:'备注',placeholder:'请输入备注',value:'',filed:'remark'},
            ]
            that.addElData.labelList = returnLableList6;
            that.dialogData = that.addElData;
            that.dialogData.width = '700'
            that.dialogData.title = `转账`
            that.dialogData.isResetbtn = true;
            that.addElData.type = '6';
            that.dialogData.dialogVisible = true;
          break;
          default:
            console.log("按钮操作")
        }
      },
      
      clearUpload(){
        //重置图片列表
        for(let item of this.uploadFileData.labelList){
                if(item.inputType == 'upload'){
                    item.fileList = [];
                      item.value = "";
                }
            }
      },
      //删除图片
      closeFun(label){
        this.$utils.echoValue(label,this.addElData.labelList,"")
        console.log("删除图片",label)
      },
      //图片上传相关操作
      handleSuccess(res, file, fileList,label,filed){
        if(res.code == 200){
          this.$message({
            message: '上传成功',
            type: 'success'
          })
            this.echoImg(label,filed,res.data.url)
            console.log(label,filed,res)
        }else{
          this.$message({
            message: '上传失败',
            type: 'error'
          })
        }
        console.log("图片上传成功",res, file,fileList)
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg'; // false
        const isPng= file.type === 'image/png'; // true
        const isLt2M = file.size / 1024 / 1024 < 2;

        if ((!isJPG && !isPng)) {
          this.$message.error('上传图片只能是 JPG 或 PNG 格式!');
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
          return false
        }
        return (isJPG || isPng) && isLt2M;
      },
      echoImg(label,filed,imgUrl){
        this.$utils.echoValue(label,this.addElData.labelList,imgUrl)
        console.log("============123123",this.addElData.labelList)
      },


      //分页操作
      handleResetSearch() {
        this.listQuery = Object.assign({}, {
          pageNum: 1,
          pageSize: 20,
        });
        this.$utils.resetObj(this.searchData);
      },
      handleSearchList() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.pageNum = val;
        this.getList();
      },
    }
  }
</script>
<style lang="scss" scoped>
  /deep/ .filter-container {
    margin-bottom: 20px;
  }

  /deep/ .el-card__body {
    padding-bottom: 0;
  }

  /deep/ .el-dialog__body {
    max-height: 75vh;
    overflow-y: scroll;
    padding: 16px 20px;
  }

  /deep/ .el-dialog__footer {
    border-top: 1px solid #dcdfe6;
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
  }

  .avatar-uploader {
    /deep/ .el-upload {
      cursor: pointer;
      position: relative;
    }

    /deep/ .el-upload:hover {
      border-color: #409eff;
    }

    /deep/ .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      line-height: 100px;
      text-align: center;
    }

    /deep/ .avatar {
      width: 100px;
      height: 100px;
      display: block;
    }
  }

  .detail-phone {
    width: 375px;
    height: 667px;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/companyBalace.vue